import React, { Component } from 'react';
import { withRouter, Link } from 'react-router-dom';
import _ from 'underscore';

import config from './../config';
import nyyrdiHelper from './../nyyrdiHelper';

class CommentsForm extends Component {
	constructor(props) {
		super(props);

		this.formInputChangeHandler = this.formInputChangeHandler.bind(this);
		this.sendButtonClickHandler = this.sendButtonClickHandler.bind(this);
		this.eventBusCommentSendSuccessHandler = this.eventBusCommentSendSuccessHandler.bind(this);

		this.state = {
			formData: {
				sendandi_nafn: '',
				sendandi_faedingarar: '',
				sendandi_netfang: '',
				sendandi_postnumer: '',
				sendandi_stadur: '',
				sendandi_hideinfo: '',
				innlegg: ''
			},
			formVisible: false,
			confirmVisible: false
		};
	}

	componentDidMount() {
		this.getUserInfo();

		window.EventBus.addEventListener('success.sendcomment', this.eventBusCommentSendSuccessHandler);
	}

	componentWillUnmount() {
		window.EventBus.removeEventListener('success.sendcomment', this.eventBusCommentSendSuccessHandler);
	}

	eventBusCommentSendSuccessHandler(event) {
		let formData = this.state.formData;
		formData.innlegg = '';

		this.setState({
			formData: formData,
			confirmVisible: true
		}, function() {
			setTimeout(function() {
				this.setState({
					confirmVisible: false
				});

				window.scrollTo({
					top: this.refs.commentsList.offsetTop-20,
					behaviour: 'smooth'
				})
				this.refs.commentsList
			}.bind(this), 1500);
		}.bind(this));
	}

	validateForm() {
		let validationError = [];
		if (this.state.formData.innlegg && 
			this.state.formData.sendandi_nafn && 
			(this.state.formData.sendandi_netfang == '' || nyyrdiHelper.validateEmail(this.state.formData.sendandi_netfang)) &&
			(this.state.formData.sendandi_postnumer == '' || !isNaN(this.state.formData.sendandi_postnumer)) &&
			(this.state.formData.sendandi_faedingarar == '' || !isNaN(this.state.formData.sendandi_faedingarar))
		) {
			this.setState({
				validationError: []
			});

			return true;
		}
		else {
			if (!this.state.formData.innlegg || !this.state.formData.sendandi_nafn) {
				validationError.push('Þú verður að skrifa nafnið þitt og athugasemd.');
			}

			if (this.state.formData.sendandi_netfang && !nyyrdiHelper.validateEmail(this.state.formData.sendandi_netfang)) {
				validationError.push('Þú verður að skrifa gilt netfang.');
			}

			if (this.state.formData.sendandi_postnumer && isNaN(this.state.formData.sendandi_postnumer)) {
				validationError.push('Þú verður að skrifa gilt póstnúmer.');
			}

			if (this.state.formData.sendandi_faedingarar && isNaN(this.state.formData.sendandi_faedingarar)) {
				validationError.push('Þú verður að skrifa gilt fæðingarár.');
			}

			this.setState({
				validationError: validationError
			});

			return false;
		}
	}

	saveUserInfo() {
		let userData = {
			sendandi_nafn: this.state.formData.sendandi_nafn,
			sendandi_netfang: this.state.formData.sendandi_netfang,
			sendandi_faedingarar: this.state.formData.sendandi_faedingarar,
			sendandi_postnumer: this.state.formData.sendandi_postnumer,
			sendandi_stadur: this.state.formData.sendandi_stadur,
			sendandi_hideinfo: this.state.formData.sendandi_hideinfo
		};

		localStorage.setItem('nyyrdi_userdata', JSON.stringify(userData));
	}

	getUserInfo() {
		if (localStorage.getItem('nyyrdi_userdata')) {
			let userData = JSON.parse(localStorage.getItem('nyyrdi_userdata'));

			let formData = this.state.formData;

			Object.assign(formData, userData);

			this.setState({
				formData: formData
			});
		}
	}

	prepareData(data) {
		let ret = {};

		for (let key in data) {
			if (data[key] != '') {
				ret[key] = data[key];
			}
		}

		return ret;
	}

	sendButtonClickHandler(event) {
		event.preventDefault();

		if (this.validateForm()) {
			this.saveUserInfo();

			if (this.props.onSendComment) {
				this.props.onSendComment(this.prepareData(this.state.formData));
			}
		}
	}

	formInputChangeHandler(event) {
		let value = event.target.type && event.target.type == 'checkbox' ? event.target.checked : event.target.value;

		let formData = this.state.formData;

		formData[event.target.name] = value;

		this.setState({
			formData: formData
		});
	}

	render() {
		return (
			<div className="comments-wrapper">
				<p className="text-center">Hér getur þú komið þínum ábendingum um nýyrðið á framfæri.</p>

				{
					!this.state.formVisible &&
					<div className="text-center">
						<button className="btn btn-primary" onClick={function() {
							this.setState({
								formVisible: true
							})
						}.bind(this)}>Skrifa athugasemd</button>
					</div>
				}

				<div className={'form-container'+(this.state.formVisible ? ' open' : '')}>
					<form className="comments-form">

						<div className={'confirm-overlay'+(this.state.confirmVisible ? ' visible' : '')}>
							<div className="message">Takk fyrir, athugasemdin þín hefur verið birt hér að neðan</div>
						</div>

						<h4><span>Skrifa athugasemd</span></h4>

						<div className="row">
							<div className="col">
								<label>Nafn</label>
								<input required 
									data-required-msg="Þú verður að skrifa í þennan reit" 
									onChange={this.formInputChangeHandler} 
									name="sendandi_nafn" 
									value={this.state.formData.sendandi_nafn} 
									type="text" 
									className="form-control" />
							</div>
							<div className="col">
								<label>Fæðingarár</label>
								<input data-required-msg="Þú verður að skrifa í þennan reit" 
									onChange={this.formInputChangeHandler} 
									name="sendandi_faedingarar" 
									value={this.state.formData.sendandi_faedingarar} 
									type="text" 
									className="form-control" />
								<small>Fæðingarár verður ekki birt.</small>
							</div>
						</div>

						<div className="row">
							<div className="col">
								<label>Netfang</label>
								<input data-required-msg="Þú verður að skrifa í þennan reit" 
									onChange={this.formInputChangeHandler} 
									name="sendandi_netfang" 
									value={this.state.formData.sendandi_netfang} 
									type="text" 
									className="form-control" />
								<small>Netfangið verður ekki birt.</small>
							</div>
						</div>

						<div className="row">
							<div className="col-md-4">
								<label>Póstnúmer</label>
								<input onChange={this.formInputChangeHandler} 
									name="sendandi_postnumer" 
									value={this.state.formData.sendandi_postnumer} 
									type="text" 
									className="form-control" />
							</div>
							<div className="col-md-8">
								<label>Staður</label>
								<input onChange={this.formInputChangeHandler} 
									name="sendandi_stadur" 
									value={this.state.formData.sendandi_stadur} 
									type="text" 
									className="form-control" />
								<small>Heimilisfang verður ekki birt.</small>
							</div>
						</div>

						<div className="row">
							<div className="col">
								<div className="form-check">
									<input onChange={this.formInputChangeHandler} 
										type="checkbox" 
										className="form-check-input" 
										id="sendandi_hideinfo" 
										checked={this.state.formData.sendandi_hideinfo}
										name="sendandi_hideinfo" />
									<label className="form-check-label">Ég vil ekki að neinar upplýsingar um mig verði sýnilegar</label>
								</div>
							</div>
						</div>

						<div className="row">
							<div className="col">
								<label>{'Þín athugasemd'}</label>
								<textarea required 
									data-required-msg="Þú verður að skrifa í þennan reit" 
									onChange={this.formInputChangeHandler} 
									name="innlegg" 
									className="form-control"
									value={this.state.formData.innlegg} />
							</div>
						</div>

						<div>
							{
								this.state.validationError && this.state.validationError.length > 0 &&
								<p><strong dangerouslySetInnerHTML={{__html: this.state.validationError.join('<br/>')}}></strong></p>
							}
							<button className="btn btn-primary" onClick={this.sendButtonClickHandler}>Senda</button>
						</div>

					</form>
				</div>

				{
					this.props.entryData && this.props.entryData.athugasemdir && this.props.entryData.athugasemdir.length > 0 &&
					<div className="comments-list" ref="commentsList">
						<h4><span>Athugasemdir</span></h4>
						{
							this.props.entryData.athugasemdir.map(function(athugasemd, index) {
								return <div key={index} className="comment">
									<p>
										<strong>
											{
												athugasemd.sendandi_nafn || '(nafnlaust)'
											}
										</strong>
										<small className="float-right">Sent inn {nyyrdiHelper.formatDate(athugasemd.inserttime)}</small>
										{
											(athugasemd.sendandi_postnumer || athugasemd.sendandi_stadur) &&
											<React.Fragment>
												<br/>
												{
													(athugasemd.sendandi_postnumer ? athugasemd.sendandi_postnumer : '')+
													(
														athugasemd.sendandi_postnumer && athugasemd.sendandi_stadur ?
														' ' :
														'' 
													)+
													(athugasemd.sendandi_stadur ? athugasemd.sendandi_stadur : '')
												}
											</React.Fragment>
										}
									</p>
									<p>{athugasemd.innlegg}</p>
								</div>
							}.bind(this))
						}
					</div>
				}
			</div>
		);
	}
}

export default withRouter(CommentsForm);



// WEBPACK FOOTER //
// ./src/components/CommentsForm.js